"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgEmptyReviews = function SvgEmptyReviews(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 166 98",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "empty-reviews_svg__a",
    d: "M60 27h48c5.523 0 10 4.477 10 10v23.9c0 5.522-4.477 10-10 10H94.573L78.139 82V70.9H60c-5.523 0-10-4.478-10-10V37c0-5.523 4.477-10 10-10z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "empty-reviews_svg__b",
    width: 68,
    height: 55,
    x: 0,
    y: 0,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#empty-reviews_svg__a"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E1F3FF",
    d: "M104 70.9c5.523 0 10-4.478 10-10V37c0-5.523-4.477-10-10-10h4c5.523 0 10 4.477 10 10v23.9c0 5.522-4.477 10-10 10zm-9.427 0L78.139 82v-2.702l12.434-8.399h4z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 46,
    r: 2,
    fill: "#17181A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 46,
    r: 2,
    fill: "#17181A"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#17181A",
    d: "M74 58c7.113-2.667 14.113-2.667 21 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m10 16-5.878 3.09 1.123-6.545L.489 7.91l6.572-.955L10 1l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545zm142 5.559L143.348 26 145 16.593l-7-6.662 9.674-1.372L152 0l4.326 8.559L166 9.93l-7 6.662L160.652 26zM127.5 95.95 123.483 98l.767-4.342-3.25-3.074 4.491-.634L127.5 86l2.009 3.95 4.491.634-3.25 3.074.767 4.342z"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#C2C5CC",
    strokeDasharray: 2,
    strokeLinejoin: "round",
    strokeWidth: 2,
    mask: "url(#empty-reviews_svg__b)",
    xlinkHref: "#empty-reviews_svg__a"
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgEmptyReviews);
var _default = exports["default"] = Memo;